import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  // مقداردهی اولیه `isAuthenticated` و `user` از localStorage
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    const storedUser = localStorage.getItem('user');
    return !!storedUser; // آیا کاربری ذخیره شده است؟ اگر بله: true
  });

  const [user, setUser] = useState(() => {
    const storedUser = localStorage.getItem('user');
    return storedUser ? JSON.parse(storedUser) : null; // اگر کاربری وجود داشت، آن را مقداردهی کن
  });

  const login = (userData) => {
    if (userData && userData.role) { // بررسی صحت داده
      setUser(userData);
      setIsAuthenticated(true);
      localStorage.setItem('user', JSON.stringify(userData)); // ذخیره در localStorage
    }
  };

  const updateUser = (updatedUser) => {
    setUser((prevUser) => ({
      ...prevUser,
      ...updatedUser,
    }));

    // به‌روزرسانی در localStorage
    localStorage.setItem(
      'user',
      JSON.stringify({
        ...user,
        ...updatedUser,
      })
    );
  };

  const logout = () => {
    setUser(null);
    setIsAuthenticated(false);
    localStorage.removeItem('user'); // حذف کاربر از localStorage
  };

  return (
    <AuthContext.Provider value={{ user, isAuthenticated, login, logout, updateUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};